/**
 * OAuth Callback Page
 * Handles the OAuth redirect from Cognito after Google sign-in
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LoadingSpinner } from '../components/common/LoadingSpinner';

const OAuthCallbackPage = () => {
  const navigate = useNavigate();
  const { checkAuthState } = useAuth();

  useEffect(() => {
    const handleOAuthCallback = async () => {
      try {
        // AWS Amplify automatically handles the OAuth code exchange
        // We just need to check the auth state to update our context
        await checkAuthState();

        // Redirect to home page after successful authentication
        navigate('/', { replace: true });
      } catch (error) {
        console.error('OAuth callback error:', error);
        // Redirect to login with error
        navigate('/login', {
          replace: true,
          state: { error: 'Google login failed. Please try again.' }
        });
      }
    };

    handleOAuthCallback();
  }, [navigate, checkAuthState]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center">
      <LoadingSpinner size="large" />
      <p className="mt-4 text-gray-600">Completing Google sign in...</p>
    </div>
  );
};

export default OAuthCallbackPage;
